import { clstx } from '@payaca/utilities/cvaMerge';
import React, { FC } from 'react';

export type TProps = {
  borderWidth?: number;
  duration?: number;
  shineColor: string | string[];
} & React.HTMLAttributes<HTMLDivElement>;

const ShineBorder: FC<TProps> = (props) => {
  const {
    className,
    borderWidth = 2,
    duration = 8,
    style,
    shineColor,
    ...rest
  } = props;

  return (
    <div
      className={clstx(
        'absolute inset-0 animate-shine rounded-[inherit] size-full will-change-[background-position]',
        className
      )}
      style={
        {
          '--border-width': `${borderWidth}px`,
          '--duration': `${duration}s`,
          backgroundImage: `radial-gradient(transparent,transparent, ${
            Array.isArray(shineColor) ? shineColor.join(',') : shineColor
          },transparent,transparent)`,
          backgroundSize: '300% 300%',
          mask: `linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)`,
          WebkitMask: `linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)`,
          WebkitMaskComposite: 'xor',
          maskComposite: 'exclude',
          padding: 'var(--border-width)',
          ...style,
        } as React.CSSProperties
      }
      {...rest}
    />
  );
};

export default ShineBorder;
